import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../../pages/home/homePage.css";

const MediaPartners = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef(null);
  const itemsToShow = 3; // Number of news items to display at a time
  const navigate = useNavigate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;

  const [partnerLogos, setPartnerLogos] = useState([]);

  const rotatePartnerLogos = () => {
    setPartnerLogos((prevLogos) => {
      const rotatedLogos = [...prevLogos];
      const firstLogo = rotatedLogos.shift();
      if (firstLogo) {
        rotatedLogos.push(firstLogo);
      }
      return rotatedLogos;
    });
  };

  const handleMediaLogo = async () => {
    try {
      const response = await fetch(`${backendUrl}api/v2/media-fetch`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
    
          },
          credentials: "include",
          mode:"cors"
       
        }
      );
      const data = await response.json();
      //console.log("logos---------->>>>>>", data);
      if (data.status && Array.isArray(data.result)) {
        setPartnerLogos(data.result.map((item:any) => item.logo_img)); // Extract logo_img URLs
      } else {
        // console.warn("Unexpected response structure:", data);
      }
    } catch (error) {
      //console.error("Error fetching media logos:", error);
    }
  };

  useEffect(() => {
    handleMediaLogo();
    // const autoScroll = setInterval(() => {
    //   rotatePartnerLogos(); // Rotate the partner logos every 10 seconds
    // }, 10000); // 10 seconds

    // // Cleanup interval on unmount
    // return () => clearInterval(autoScroll);
  }, []);

  return (
    <section className="partner media">
        <div className="container">
        <div className="container-partners-logos">
          <h2 className="headingText">In The Media</h2>
          <div className="slider">
            <div className="slide-track">
              {partnerLogos.map((logo, index) => (
                <div className="slide-partner" key={index}>
                  <img src={logo} alt={`Partner logo ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaPartners;
